"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _columnTypes = _interopRequireDefault(require("./columnTypes"));
var _rowTypes = _interopRequireDefault(require("./rowTypes"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdSurveyMultipleChoice = require("cccisd-survey-multiple-choice");
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = exports.fields = function () {
  var result = [];

  // Column types
  (0, _forEach2["default"])(_columnTypes["default"], function (columnType, name) {
    columnType.fields.forEach(function (field) {
      result.push("columnTypes.".concat(name, "[].").concat(field));
    });
  });

  // Row types
  (0, _forEach2["default"])(_rowTypes["default"], function (rowType, name) {
    rowType.fields.forEach(function (field) {
      result.push("rowTypes.".concat(name, "[].").concat(field));
    });
  });
  return ['question', 'description',
  // Options
  'allowUserRows', 'addUserRowText', 'userRowPlaceholder', 'minUserRows', 'maxUserRows', 'rowPrefix', 'rowHeaderWidth', 'cornerHeader', 'isBorderedStyle', 'isStripedRowsStyle', 'isStripedColumnsStyle', 'questionNumbersExpanded', 'questionNumbersHide', 'questionNumbersForMainQuestion', 'questionNumbersForRows', 'questionNumbersReset', 'questionNumbersResetNumber',
  // Rows
  'rows[].id', 'rows[].type', 'rows[].label', 'rows[].position', 'rows[].variableName', 'rows[].codebookName', 'rows[].isExpanded', 'rows[].isCellExpanded', 'rows[].isVariablesExpanded',
  // Columns
  'columns[].id', 'columns[].type', 'columns[].label', 'columns[].width', 'columns[].position', 'columns[].headerPosition', 'columns[].isHeaderExpanded', 'columns[].isCellExpanded', 'columns[].isExpanded', 'columns[].template', 'columns[].templateSettings', 'columns[].isTemplateExpanded'].concat(result);
}();
var ttsFields = exports.ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings;
  var result = ['question', 'description'];
  result.push.apply(result, _toConsumableArray(settings.rows.map(function (item, index) {
    return "rows[".concat(index, "].label");
  })));
  result.push.apply(result, _toConsumableArray(settings.columns.map(function (item, index) {
    return "columns[".concat(index, "].label");
  })));
  var _loop = function _loop() {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (!value.ttsFields) {
        return 0; // continue
      }
      if (!settings.columnTypes[key]) {
        return 0; // continue
      }
      settings.columnTypes[key].forEach(function (item, index) {
        var columnTtsFields = typeof value.ttsFields === 'function' ? value.ttsFields({
          settings: item,
          isMatrixMode: true
        }) : value.ttsFields;
        result.push.apply(result, _toConsumableArray(columnTtsFields.map(function (name) {
          return "columnTypes.".concat(key, "[").concat(index, "].").concat(name);
        })));
      });
    },
    _ret;
  for (var _i = 0, _Object$entries = Object.entries(_columnTypes["default"]); _i < _Object$entries.length; _i++) {
    _ret = _loop();
    if (_ret === 0) continue;
  }
  return result;
};
var initialValues = exports.initialValues = {
  question: '<p><strong>What is your opinion about...?</strong></p>',
  addUserRowText: 'Add new row',
  userRowPlaceholder: 'Please specify',
  maxUserRows: '3',
  rowHeaderWidth: '30%',
  isBorderedStyle: true,
  isStripedRowsStyle: false,
  isStripedColumnsStyle: false,
  questionNumbersForMainQuestion: true,
  rows: [{
    id: 1,
    type: 'static',
    label: 'Row',
    position: 'top-left'
  }, {
    id: 2,
    type: 'static',
    label: 'Row',
    position: 'top-left'
  }, {
    id: 3,
    type: 'static',
    label: 'Row',
    position: 'top-left'
  }],
  rowTypes: {
    "static": [{
      id: 1
    }]
  },
  columns: [{
    id: 1,
    type: 'multipleChoice',
    label: '',
    position: 'top-left',
    headerPosition: 'top-left'
  }],
  columnTypes: {
    openEnded: [],
    checkbox: [],
    multipleChoice: [_objectSpread(_objectSpread({}, _cccisdSurveyMultipleChoice.builderInitialValues), {}, {
      id: 1,
      verticalOrHorizontal: 'horizontal',
      showLabelsInMatrixHeader: true
    })],
    slider: []
  }
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-th"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  (0, _forEach2["default"])(_columnTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.columnTypes[type], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      columnTypes: _objectSpread(_objectSpread({}, errors.columnTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  (0, _forEach2["default"])(_rowTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.rowTypes[type], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      rowTypes: _objectSpread(_objectSpread({}, errors.rowTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  if (values.allowUserRows) {
    if (values.minUserRows && !(0, _isInt["default"])(values.minUserRows, {
      min: 0,
      max: 15
    })) {
      errors.minUserRows = 'Value should be the number between 0 and 15';
    }
    if (!values.maxUserRows || !(0, _isInt["default"])(values.maxUserRows, {
      min: 1,
      max: 15
    })) {
      errors.maxUserRows = 'Value should be the number between 1 and 15';
    }
    if (!errors.minUserRows && !errors.maxUserRows) {
      if (values.maxUserRows * 1 < values.minUserRows * 1) {
        errors.maxUserRows = 'Max value should be greater than min value';
      }
    }
  }
  if (!values.questionNumbersHide && values.questionNumbersReset && !(0, _isInt["default"])(values.questionNumbersResetNumber, {
    min: 1,
    max: 9999
  })) {
    errors.questionNumbersResetNumber = 'Enter whole number from 1 to 9999';
  }
  return errors;
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'mx';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var question = settings.question,
    rows = settings.rows,
    columns = settings.columns,
    allowUserRows = settings.allowUserRows,
    maxUserRows = settings.maxUserRows;
  var metricsPrefix = getMetricsPrefix();
  var data = {};
  rows.forEach(function (row) {
    columns.forEach(function (column) {
      var prefix = id + '_answer_' + row.id + '_';
      if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getDataDefinitions) {
        var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
          id: column.id
        });
        var dataDefinitions = _columnTypes["default"][column.type].getDataDefinitions(column.id, columnSettings, true);
        (0, _forEach2["default"])(dataDefinitions, function (value, key) {
          data[prefix + key] = _objectSpread(_objectSpread({}, value), {}, {
            reportHeader: "".concat(metricsPrefix, "_").concat(id, "_").concat(row.id, "_").concat(value.reportHeader),
            title: (0, _cccisdSurveyCommon.stripTags)(question),
            titleHtml: question,
            subtitle1: (0, _cccisdSurveyCommon.stripTags)(row.label),
            subtitle1Html: row.label,
            subtitle2: (0, _cccisdSurveyCommon.stripTags)(column.label),
            subtitle2Html: column.label,
            matrixRow: row.id,
            matrixColumn: column.id
          });
        });
      }
    });
  });
  if (allowUserRows) {
    var _loop2 = function _loop2(i) {
      data["".concat(id, "_answer_user_row_").concat(i, "_text")] = {
        title: (0, _cccisdSurveyCommon.stripTags)(question),
        titleHtml: question,
        variableType: 'answer',
        reportHeader: "".concat(metricsPrefix, "_").concat(id, "_user_row_").concat(i, "_text"),
        subtitle1: 'User row',
        subtitle1Html: '<p>User row</p>',
        matrixRow: "User Row ".concat(i, " Text"),
        matrixColumn: null,
        type: 'text',
        questionType: 'matrix',
        tags: {
          system: ['answer']
        }
      };
      columns.forEach(function (column) {
        var prefix = "".concat(id, "_answer_user_row_").concat(i, "_");
        if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getDataDefinitions) {
          var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
            id: column.id
          });
          var dataDefinitions = _columnTypes["default"][column.type].getDataDefinitions(column.id, columnSettings, true);
          (0, _forEach2["default"])(dataDefinitions, function (value, key) {
            data[prefix + key] = _objectSpread(_objectSpread({}, value), {}, {
              variableType: 'answer',
              reportHeader: "".concat(metricsPrefix, "_").concat(id, "_user_row_").concat(i, "_").concat(value.reportHeader),
              title: (0, _cccisdSurveyCommon.stripTags)(question),
              titleHtml: question,
              subtitle1: 'User row',
              subtitle1Html: '<p>User row</p>',
              subtitle2: (0, _cccisdSurveyCommon.stripTags)(column.label),
              subtitle2Html: column.label,
              matrixRow: "User Row ".concat(i),
              matrixColumn: column.id
            });
          });
        }
      });
    };
    for (var i = 0; i < maxUserRows * 1; i++) {
      _loop2(i);
    }
  }
  return data;
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings) {
  var answer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rows = settings.rows,
    columns = settings.columns;
  var result = {};

  // Handle static rows
  rows.filter(function (item) {
    return item.type === 'static';
  }).forEach(function (row) {
    columns.forEach(function (column) {
      var prefix = id + '_answer_' + row.id + '_';
      if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getMetrics) {
        var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
          id: column.id
        });
        var columnAnswer = answer["cell_".concat(row.id, "_").concat(column.id)];
        var metrics = _columnTypes["default"][column.type].getMetrics(column.id, columnSettings, columnAnswer);
        (0, _forEach2["default"])(metrics, function (value, key) {
          result[prefix + key] = value;
        });
      }
    });
  });

  // Handle user created rows
  if (answer.userRows) {
    answer.userRows.forEach(function (row, index) {
      result["".concat(id, "_answer_user_row_").concat(index, "_text")] = row.label;
      columns.forEach(function (column) {
        var prefix = "".concat(id, "_answer_user_row_").concat(index, "_");
        if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getMetrics) {
          var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
            id: column.id
          });
          var columnAnswer = row["column_".concat(column.id)];
          var metrics = _columnTypes["default"][column.type].getMetrics(column.id, columnSettings, columnAnswer);
          (0, _forEach2["default"])(metrics, function (value, key) {
            result[prefix + key] = value;
          });
        }
      });
    });
  }

  // Handle UserLists rows
  rows.filter(function (item) {
    return item.type === 'userList';
  }).forEach(function (row) {
    columns.forEach(function (column) {
      var prefix = id + '_answer_' + row.id + '_';
      if (_columnTypes["default"][column.type] && _columnTypes["default"][column.type].getMetrics && answer["cell_".concat(row.id)]) {
        var columnSettings = (0, _find2["default"])(settings.columnTypes[column.type], {
          id: column.id
        });
        answer["cell_".concat(row.id)].forEach(function (user) {
          var columnAnswer = user["column_".concat(column.id)];
          var metrics = _columnTypes["default"][column.type].getMetrics(column.id, columnSettings, columnAnswer);
          (0, _forEach2["default"])(metrics, function (value, key) {
            result[prefix + key] = result[prefix + key] || {};
            result[prefix + key].pawns = result[prefix + key].pawns || [];
            result[prefix + key].pawns.push({
              pawnId: user.pawnId,
              pawnHash: user.pawnHash,
              value: value
            });
          });
        });
      }
    });
  });
  return result;
};